import React from "react";
import { ArrowDownIcon, HelpCircleIcon } from "lucide-react";
import { learningSources, reviewQuestions, startQuestions } from "../../data/content";
import { CTAButton } from "../CTAButton";
export function Problem() {
  return <>
      <section className="bg-ink px-4 py-16 text-white" data-id="element-216" data-mp="2rmkcwi001cl7">
        <div className="mx-auto max-w-3xl" data-id="element-217" data-mp="2mq3p5owpp08n">
          <h2 className="text-center font-serif text-[30px] font-bold leading-tight sm:text-5xl" data-id="element-218" data-mp="2mp236pe5qtc5">
            From a revision case that feels difficult to untangle…
          </h2>
          <ArrowDownIcon className="mx-auto my-4 h-8 w-8 text-gold" aria-hidden data-id="element-219" data-mp="2cqcvfpfz6p9m" />
          <p className="text-center font-serif text-[26px] font-bold italic leading-tight text-goldsoft sm:text-4xl" data-id="element-220" data-mp="28qkhex7tbqwv">
            …to a case you can review with a structured process.
          </p>

          <p className="mt-10 text-center text-[17px] leading-relaxed text-white/80" data-id="element-221" data-mp="6yfr1q5yp1o9">
            When you’re looking at a liposuction revision case, the challenge isn’t always finding more information.
            Sometimes the real challenge is knowing:
          </p>

          <ul className="mt-6 space-y-2.5" data-id="element-222" data-mp="199wtg8bhlkkb">
            {reviewQuestions.map(q => <li key={q} className="flex items-center gap-3 rounded-xl bg-white/[0.06] px-4 py-3.5" data-id="element-223" data-mp="vadlpgml8b8j">
                <HelpCircleIcon className="h-5 w-5 shrink-0 text-gold" aria-hidden data-id="element-224" data-mp="109gt37q1itjo" />
                <span className="text-[17px] font-semibold" data-id="element-225" data-mp="10bbeso94ypot">{q}</span>
              </li>)}
          </ul>

          <p className="mt-8 text-center text-[18px] font-semibold" data-id="element-226" data-mp="1s0mt7o5rgr8y">
            That’s exactly why I created the <span className="text-goldsoft" data-id="element-227" data-mp="1e9hr8fex7mvg">Lipo Revision Case Atlas™</span>.
          </p>

          <div className="mt-8 grid grid-cols-3 gap-2 text-center" data-id="element-228" data-mp="1j8cje7ys2ns8">
            {[{
            n: "6",
            l: "Premium volumes"
          }, {
            n: "5",
            l: "Bonuses"
          }, {
            n: "30+",
            l: "Review tools"
          }].map(s => <div key={s.l} className="rounded-xl border border-gold/40 px-2 py-4" data-id="element-229" data-mp="2bpf59kgilvp4">
                <p className="font-serif text-[34px] font-bold leading-none text-goldsoft" data-id="element-230" data-mp="2ljkqso863bq6">{s.n}</p>
                <p className="mt-1.5 text-[12px] font-semibold uppercase tracking-wide text-white/75" data-id="element-231" data-mp="2gmkjyb3hu4y0">{s.l}</p>
              </div>)}
          </div>
        </div>
      </section>

      <section className="bg-cream px-4 py-16" data-id="element-232" data-mp="26o4s25wn6rng">
        <div className="mx-auto max-w-2xl" data-id="element-233" data-mp="26pfw86u021f3">
          <h2 className="font-serif text-[28px] font-bold leading-tight text-ink sm:text-4xl" data-id="element-234" data-mp="22m9unchu0yey">
            I created this system because I kept seeing the same problem.
          </h2>
          <ul className="mt-6 space-y-2 text-[17px] text-ink" data-id="element-235" data-mp="1svowfq62lvwk">
            {learningSources.map(s => <li key={s} className="border-l-4 border-gold/60 pl-4 py-1" data-id="element-236" data-mp="1nxdnririhrfx">{s}</li>)}
          </ul>
          <p className="mt-6 text-[19px] font-bold text-ink" data-id="element-237" data-mp="1iy0ofyjgerwg">
            And then a revision case comes in… and you still have to figure out:
          </p>
          <ul className="mt-4 grid gap-2 sm:grid-cols-2" data-id="element-238" data-mp="1eyjil4047sqr">
            {startQuestions.map(q => <li key={q} className="rounded-xl bg-white px-4 py-3 text-[16px] font-semibold text-navy shadow-sm" data-id="element-239" data-mp="3qlvdq6ksfqt8">
                {q}
              </li>)}
          </ul>
          <div className="mt-8 rounded-2xl bg-sand p-5 text-[17px] leading-relaxed text-ink" data-id="element-240" data-mp="3fm9a56notab">
            <p data-id="element-241" data-mp="8d4mi7rphuo4">The problem isn’t always a lack of knowledge.</p>
            <p className="mt-3" data-id="element-242" data-mp="36wb9zajk58s2">
              Sometimes the problem is that there is <strong data-id="element-243" data-mp="3bud36oap6oh9">no repeatable process</strong> for reviewing what happened
              and extracting useful learning from the case.
            </p>
            <p className="mt-3 font-semibold" data-id="element-244" data-mp="3gs4w9ln2wgn1">That’s exactly what I built the Lipo Revision Case Atlas™ to help you do.</p>
          </div>
          <CTAButton className="mt-10" label="I want to review revision cases with a system" data-id="element-245" data-mp="2o51wyrakw1vq" />
        </div>
      </section>
    </>;
}